import { ApplicationRef, ElementRef, Injectable, Optional, inject, provideAppInitializer } from '@angular/core';
import { BehaviorServiceConfig, BehaviorServiceConfigDefault } from './lib';
import info_json from './tmp/info.json';
import { fromEvent } from 'rxjs';
import { debounceTime, startWith, first } from 'rxjs/operators';
import { initRootNode } from './change-observer';

@Injectable(
    { providedIn: 'root' }
)
export class WBehaviorService {
    private _applicationRoot?: Promise<ElementRef<HTMLElement>>;
    protected cfg = new BehaviorServiceConfigDefault();

    get mobile() {
        return this.cfg.mobile();
    }
    constructor(@Optional() config?: BehaviorServiceConfig) {
        if (config) {
            this.cfg = { ...config };
        }
        /* set w-angular version on app root */
        const appRef = inject(ApplicationRef);
        if (appRef) {
            appRef.isStable.pipe(first()).subscribe(() => {
                setTimeout(() => {
                    const checkComponent = () => {
                        if (appRef.components.length > 0) {
                            this._applicationRoot = new Promise((resolve: (value: ElementRef<HTMLElement>) => void) => {
                                resolve(appRef.components[0].injector.get(ElementRef));
                            });
                            this._applicationRoot.then((r: ElementRef<HTMLElement>) => {
                                r.nativeElement.setAttribute('w-ng-version', info_json.version);
                                // set size to use in CSS of absolute/fixed elements
                                fromEvent(window, 'resize').pipe(debounceTime(100), startWith([0])).subscribe(() => {
                                    r.nativeElement.style.setProperty('--w-ng-page-width', `${document.body.clientWidth}px`);
                                });
                            });
                        } else {
                            setTimeout(checkComponent, 10);
                        }
                    };
                    checkComponent();
                }, 0);
            });
        }
    }
}

export const provideWAngular = () => provideAppInitializer(() => {
    inject(WBehaviorService);
});